import { Stack, Text } from 'braid-design-system';
import { InlineCode, SmartTextLink } from 'scoobie';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import type { Breadcrumb } from '#src/components/Breadcrumbs/Breadcrumbs.tsx';
import { HirerList } from './components/HirerList/HirerList.tsx';

export const HirersPage = ({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) => (
  <BasePage title="Hirer relationships" breadcrumbs={breadcrumbs}>
    <Stack space="medium">
      <Text>
        View the SEEK hirers you have an{' '}
        <SmartTextLink href="/auth/hirer-relationships">
          active relationship
        </SmartTextLink>{' '}
        with, and check their configured relationships and application methods.
      </Text>

      <Text>
        For automated use cases, you can use the{' '}
        <SmartTextLink href="/schema/query/hiringOrganization">
          <InlineCode>hiringOrganization</InlineCode> query
        </SmartTextLink>{' '}
        to programmatically query a hirer from the SEEK API, and the{' '}
        <SmartTextLink href="/schema/webhooks/HirerRelationshipChangedEvent">
          <InlineCode>HirerRelationshipChanged</InlineCode> event
        </SmartTextLink>{' '}
        to keep in sync with changes.
      </Text>
    </Stack>

    <HirerList />
  </BasePage>
);
